import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../modules/jobFunctions/dobNoteActions'
import * as api from '../../api/job/dobNotes'

function* dobNotesRefresh(action) {
  try {
    const payload = yield call(api.getDobNotes, action.jobId)
    yield put({ type: constants.DOB_NOTES_REFRESH.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DOB_NOTES_REFRESH.FAILED,
      message: e.message || e
    })
  }
}

function* watchDobNotes() {
  yield takeLatest(constants.DOB_NOTES_REFRESH.ACTION, dobNotesRefresh)
}

function* sagaCreateDobNote(action) {
  try {
    const payload = {
      job_id: action.jobId,
      content: action.description,
      created_by_id: action.userId,
      updated_by_id: action.userId
    }
    yield call(api.createDobNote, payload)
    yield put({ type: constants.DOB_NOTE_CREATE.SUCCESS, payload })
    yield call(dobNotesRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DOB_NOTE_CREATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateDobNote() {
  yield takeLatest(constants.DOB_NOTE_CREATE.ACTION, sagaCreateDobNote)
}

function* sagaUpdateDobNote(action) {
  try {
    const payload = {
      job_id: action.jobId,
      dob_note_id: action.noteId,
      content: action.description,
      updated_by_id: action.userId
    }
    yield call(api.updateDobNote, payload)
    yield put({ type: constants.DOB_NOTE_UPDATE.SUCCESS, payload })
    yield call(dobNotesRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DOB_NOTE_UPDATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateDobNote() {
  yield takeLatest(constants.DOB_NOTE_UPDATE.ACTION, sagaUpdateDobNote)
}

function* sagaDeleteDobNote(action) {
  try {
    const payload = {
      dob_note_id: action.noteId
    }
    yield call(api.deleteDobNote, payload)
    yield put({ type: constants.DOB_NOTE_DELETE.SUCCESS, payload })
    yield call(dobNotesRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DOB_NOTE_DELETE.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteDobNote() {
  yield takeLatest(constants.DOB_NOTE_DELETE.ACTION, sagaDeleteDobNote)
}

export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchDobNotes),

    fork(watchCreateDobNote),
    fork(watchUpdateDobNote),
    fork(watchDeleteDobNote)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/jobFunctions/dobNoteSaga.js